import { Platform } from 'react-native';
import { tv } from '@/common/theme/tv.config';

export const styles = {
  trigger: 'outline-none',
  content: tv({
    base: 'z-10 w-full min-w-[var(--radix-dropdown-menu-trigger-width)] cursor-pointer rounded-md bg-neutral10 shadow-resting-neutral10 web:overflow-hidden',
  }),
  group: 'max-h-[25.4rem]',
  item: 'p-md focus:outline-none focus:ring-0 focus:border-0 focus:bg-neutral20 hover:bg-neutral20 w-full',
  bottomSheet: `${Platform.OS === 'web' ? 'fixed' : 'absolute'} bottom-0 left-0 right-0 top-0  overflow-hidden`,
  header: 'px-md py-lg',
  handle:
    'absolute top-sm left-1/2 -translate-x-1/2 h-xs w-[6.4rem] bg-neutral40 rounded-md',
  option: 'flex-row px-lg py-md hover:bg-neutral10 gap-sm',
  optionsContainer:
    'mx-md mb-xl rounded-md bg-neutral10 shadow-resting-neutral10 overflow-hidden',
};
